// File: src/components/DocumentLayout.js
import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import html2pdf from "html2pdf.js";

const DocumentLayout = ({ title, description, children, onSave }) => {
    const componentRef = useRef();

    // ✅ Print (only document area)
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: title || "Document",
    });

    // ✅ Download (as PDF)
    // const handleDownload = () => {
    //     const element = componentRef.current;
    //     const opt = {
    //         margin: 0.5,
    //         filename: `${title || "document"}.pdf`,
    //         image: { type: "jpeg", quality: 0.98 },
    //         html2canvas: { scale: 2 },
    //         jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    //     };
    //     html2pdf().from(element).set(opt).save();
    // };

    const handleDownload = () => {
        const element = componentRef.current.cloneNode(true);

        // सारे input/textarea को उनके values से replace करना
        element.querySelectorAll("input, textarea").forEach((el) => {
            const text = document.createElement("p");
            text.innerText = el.value || el.placeholder || "";
            text.style.cssText = "margin:4px 0; white-space:pre-wrap;";
            el.replaceWith(text);
        });

        const opt = {
            margin: 0.5,
            filename: `${title || "document"}.pdf`,
            image: { type: "jpeg", quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
        };

        html2pdf().from(element).set(opt).save();
    };

    return (
        <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl mx-auto">
                {/* Header */}
                <div className="bg-white rounded-lg shadow-md p-6 mb-6">
                    <div className="flex flex-col sm:flex-row sm:items-center justify-between">
                        <div>
                            <h1 className="text-2xl font-bold text-gray-800">{title}</h1>
                            <p className="text-gray-600 mt-2">{description}</p>
                        </div>
                        <div className="flex space-x-2 mt-4 sm:mt-0">
                            <button
                                onClick={onSave}
                                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                            >
                                Save
                            </button>
                            <button
                                onClick={handleDownload}
                                className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
                            >
                                Download
                            </button>
                            {/* <button
                                onClick={handlePrint}
                                className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
                            >
                                Print
                            </button> */}
                        </div>
                    </div>
                </div>

                {/* Content */}
                <div ref={componentRef} className="bg-white rounded-lg shadow-md p-6">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default DocumentLayout;
